import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchCompanyProfile } from '../../api/companyProfileService';

import { companyProfileKeys } from './keys';

export const companyProfileOptions = () =>
	queryOptions({
		queryKey: companyProfileKeys.detail(),
		queryFn: fetchCompanyProfile,
		staleTime: STALE_TIMES.STABLE,
		retry: 2,
	});

export function useCompanyProfile() {
	return useQuery(companyProfileOptions());
}
